export function VKShare(url, text, image) {
  const shortURL = encodeURIComponent(url);
  const w = 500;
  const h = 400;
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;
  const iUrl = `http://vk.com/share.php?url=${shortURL}&title=${text}&imageUrl=${image}`;
  window.open(
    iUrl,
    '',
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`,
  );
}

export function OKShare(url) {
  const shortURL = encodeURIComponent(url);
  const w = 500;
  const h = 400;
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;
  const iUrl = `https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&service=odnoklassniki&st.shareUrl=${shortURL}`;
  window.open(
    iUrl,
    '',
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`,
  );
}
